import utiles from "@/modules/Shared/utiles/utiles";
import FormatoService from "../services/FormatoService"
import Swal from "sweetalert2";

const FormatoSV = new FormatoService();

export default
{
    namespaced: true,
    modules: {
        utiles
    },
    state:
    {
        listFormatos: [],
        formato:
        {
            nombre: "",
            descripcion: ""
        },

        formatoDefault:
        {
            nombre: "",
            descripcion: ""
        },

        loading: false
    },

    mutations:
    {
        setFormato(state, payload)
        {
            state.formato = Object.assign({}, payload)
        },

        setFormatos(state, payload)
        {
            state.listFormatos = payload
        },

        editFormato(state, formato)
        {
            state.formato = formato
        },

        resetFormato(state)
        {
            state.formato = Object.assign({}, state.formatoDefault)
        }
    },


    actions:
    {
        async getFormatosAxios({commit,state})
        {
            state.loading = true;

            try{

                const data = await FormatoSV.getAll();

                state.loading = false;

                commit('setFormatos', data)

            }catch(error)
            {
                console.log(error)

                state.loading = false;
            }
        },

        async createFormatoAxios({commit, dispatch, state})
        {
            commit('utiles/alertLoading')
            try
            {
                const data = await FormatoSV.create(state.formato)

                commit('resetFormato')

                commit('utiles/alertConfirm', 'Se registró un nuevo formato')

                dispatch('getFormatosAxios')
            }
            catch(error)
            {
                console.log(error)

                commit('utiles/alertError')
            }
        },

        async updateFormatoAxios({commit, dispatch, state})
        {
            commit('utiles/alertLoading')
            try
            {
                const data = await FormatoSV.update(state.formato)

                commit('resetFormato')

                commit('utiles/alertConfirm', 'Se actualizó el formato')

                dispatch('getFormatosAxios')
            }
            catch(error)
            {
                console.log(error)

                commit('utiles/alertError')
            }
        },

        async deleteFormatoAxios({commit, dispatch, state}, id)
        {
           const confirm = await Swal.fire({
                title: "¿Desea eliminar este formato?",
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: "CONFIRMAR"
            })

            if(!confirm.isConfirmed){return }

            commit('utiles/alertLoading')
            try
            {
                await FormatoSV.delete(id)

                commit('utiles/alertConfirm', 'Se eliminó el formato')

                dispatch('getFormatosAxios')
            }
            catch(error)
            {
                console.log(error)

                commit('utiles/alertError')
            }
        },
    }

}
